import { Listing, SearchListing, Pagination, Action } from '@root/types';
import normalize from '@shared/normalize';

export type ListingsStoreState = {
  byId: { [id: string]: Listing };
  searchResults: { [id: string]: SearchListing };
  pagination: Pagination | null;
  listingShare: Listing | null;
};
const defaultState = { byId: {}, searchResults: {}, pagination: null, listingShare: null };

export default function listingsReducer(state: ListingsStoreState = defaultState, action: Action) {
  switch (action.type) {
    case 'LISTING_SEARCH_PAGE_SERVER_SIDE_RENDER_INITIAL_LOAD': {
      const { listings, pagination } = action.payload;
      const ids = listings.map(listing => listing.id);

      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          ...normalize(listings),
        },
        pagination: {
          ...pagination,
          ids,
        },
      };
    }

    case 'LISTING_PAGE_SERVER_SIDE_RENDER_INITIAL_LOAD':
    case 'RECEIVE_FETCH_LISTING': {
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: action.payload,
        },
      };
    }
    case 'LISTING_SHARE_PAGE_SERVER_SIDE_RENDER_INITIAL_LOAD': {
      return {
        ...state,
        listingShare: action.payload,
      };
    }
    case 'RECEIVE_SEARCH_LISTINGS': {
      const { listings, pagination } = action.payload;
      const ids = listings.map(listing => listing.id);
      const normalizedListings = normalize(listings);

      return {
        ...state,
        searchResults: { ...state.searchResults, ...normalizedListings },
        pagination: {
          ...pagination,
          ids,
        },
      };
    }

    default:
      return state;
  }
}
